var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0H3.5C1.575 0 0 1.575 0 3.5V31.5C0 33.425 1.575 35 3.5 35H31.5C33.425 35 35 33.425 35 31.5V3.5C35 1.575 33.425 0 31.5 0ZM10.5 29.75H5.25V14H10.5V29.75ZM7.875 11.025C6.125 11.025 4.725 9.625 4.725 7.875C4.725 6.125 6.125 4.725 7.875 4.725C9.625 4.725 11.025 6.125 11.025 7.875C11.025 9.625 9.625 11.025 7.875 11.025ZM29.75 29.75H24.5V20.475C24.5 19.0751 23.275 17.85 21.875 17.85C20.475 17.85 19.25 19.0751 19.25 20.475V29.75H14V14H19.25V16.1C20.125 14.7 22.05 13.65 23.625 13.65C26.95 13.65 29.75 16.45 29.75 19.775V29.75Z",
    fill: "#C42B7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.73d7a7514a3bedb0720c79ce92ff1a0c.svg";
export { ForwardRef as ReactComponent };